import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDictOptions } from '@/service/components';

// 与 enumOptionsSlice 同思路；字典接口额外兼容 body.data / records 数组
const processSingleDataType = ({ data, dataType }) => {
  let list = data;
  if (list && !Array.isArray(list)) {
    if (Array.isArray(list.records)) {
      list = list.records;
    } else if (Array.isArray(list.data)) {
      list = list.data;
    }
  }
  if (!Array.isArray(list)) return [];

  if (!dataType || dataType === 'default') {
    return list;
  }

  switch (dataType) {
    case 'option':
      return list.map((item) => ({
        id: `${item.value}`,
        value: item.desc ?? item.label
      }));
    default:
      return list;
  }
};

const initialState = {
  /** GET /common/dict/options?typeCode=nursing_type */
  nursing_type: {
    data: [],
    query: {},
    fetching: false,
    error: null
  }
};

export const fetchDictOptions = createAsyncThunk(
  'dictOptions/fetchDictOptions',
  async ({ typeCode, query = {}, dataType }, { rejectWithValue }) => {
    try {
      const response = await getDictOptions({ typeCode, ...query });
      return {
        data: response.data,
        query,
        typeCode,
        dataType
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取字典选项失败');
    }
  }
);

const dictOptionsSlice = createSlice({
  name: 'dictOptions',
  initialState,
  reducers: {
    resetDictOptionsState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDictOptions.pending, (state, action) => {
        const { typeCode: code, query: argQuery = {} } = action.meta.arg;
        state[code].fetching = true;
        state[code].error = null;
        state[code].query = { typeCode: code, ...argQuery };
        state[code].data = [];
      })
      .addCase(fetchDictOptions.fulfilled, (state, action) => {
        const { data, dataType, query, typeCode } = action.payload;
        state[typeCode].fetching = false;
        state[typeCode].error = null;
        state[typeCode].query = { typeCode, ...(query || {}) };
        state[typeCode].data = processSingleDataType({ data, dataType });
      })
      .addCase(fetchDictOptions.rejected, (state, action) => {
        const { typeCode: code } = action.meta.arg;
        state[code].fetching = false;
        state[code].error = action.payload;
        state[code].data = [];
      });
  }
});

export const { resetDictOptionsState } = dictOptionsSlice.actions;
export default dictOptionsSlice.reducer;
